// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"118":"7421e20a","212":"de1b37a0","842":"15fb3183","889":"e9978759"}[chunkId] + ".js";
};